<template>
  <div class="row">
    <div v-if="!param.vendorFlag" class="col-12">
      <!-- 위험등록부 목록 -->
      <c-table
        ref="tableRisk"
        title="LBL0001203"
        tableId="riskRegister01"
        :columns="gridRisk.columns"
        :data="riskReduce.riskbooks"
        :merge="gridRisk.merge"
        :gridHeight="setheight"
        :usePaging="false"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'picture'">
            <q-icon
              size="sm"
              color="blue"
              name="image"
              class="cursor-pointer"
              @click.stop="openImprPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'customCol'">
            <component
              :is="imprComponent"
              :col="col"
              :props="props"
              :inputEditable="false"
              :requestContentsCols="requestContentsCols"
              tableKey="ram4mAssessScenarioId"
              ibmTaskTypeCd="ITT0000023"
              ibmTaskUnderTypeCd="ITTU000030"
              @imprChange="imprChange"
            />
          </template>
        </template>
      </c-table>
    </div>
    <div class="col-12">
      <!-- 개선 목록 -->
      <c-table
        ref="tableImpr"
        title="LBL0001174"
        tableId="impr01"
        :columns="gridImpr.columns"
        :data="riskReduce.imprs"
        :merge="gridImpr.merge"
        :gridHeight="setheight"
        :usePaging="false"
        @linkClick="linkClick"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'picture'">
            <q-icon
              size="sm"
              color="blue"
              name="image"
              class="cursor-pointer"
              @click.stop="openImprPicture(props)"
            />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "fm-register-TL",
  props: {
    param: {
      type: Object,
      default: function () {
        return {
          ramRiskAssessmentPlanId: "",
          ramStepCd: "",
          vendorFlag: false,
        };
      },
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      riskReduce: {
        imprs: [],
        riskbooks: [],
      },
      gridRisk: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "processJob" },
          { index: 2, colName: "ram4mRiskHazardClassGroup" },
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "제조공정",
            align: "left",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "공정흐름(작업절차)",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ram4mRiskHazardClassName",
            field: "ram4mRiskHazardClassName",
            // 평가구분(4M)
            label: "LBL0001112",
            align: "left",
            style: "width:140px",
            sortable: false,
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 유해위험요인
            label: "LBL0001050",
            align: "left",
            style: "width:170px",
            sortable: false,
          },
          // {
          //   name: 'relationLaw',
          //   field: 'relationLaw',
          //   // 관련법규
          //   label: 'LBL0001021',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          // {
          //   name: 'damageTargetName',
          //   field: 'damageTargetName',
          //   // 피해대상
          //   label: 'LBL0001185',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          {
            name: "damageTypeNameName",
            field: "damageTypeNameName",
            // 재해형태
            label: "LBL0001186",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "existingRiskManagementActivities",
            field: "existingRiskManagementActivities",
            label: "현재안전조치",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "before",
            field: "before",
            label: "현재위험도",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: 'picture',
            field: 'picture',
            label: '개선 전/후 사진',
            align: 'center',
            type: 'custom',
            style: 'width:70px',
            sortable: false,
          },
          {
            name: "addingRiskManagementActivities",
            field: "addingRiskManagementActivities",
            label: "개선방향(대책)",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "improveFlagName",
            field: "improveFlagName",
            label: "개선진행여부",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "customCol",
            field: "customCol",
            label: "LBLIMPRNO_PROGRESS",
            align: "center",
            style: "width:150px",
            type: "custom",
            sortable: false,
          },
          {
            name: "after",
            field: "after",
            label: "개선후 위험도",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            userId: "assessUserId",
            style: "width:80px",
            sortable: false,
          },
        ],
        height: "500px",
      },
      gridImpr: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "ram4mRiskHazardClassGroup" },
          { index: 3, colName: "ram4mAssessScenarioId" },
          { index: 4, colName: "ram4mAssessScenarioId" },
          { index: 5, colName: "ram4mAssessScenarioId" },
          { index: 6, colName: "ram4mAssessScenarioId" },
          { index: 7, colName: "ram4mAssessScenarioId" },
          { index: 8, colName: "ram4mAssessScenarioId" },
          { index: 9, colName: "ram4mAssessScenarioId" },
          { index: 10, colName: "ram4mAssessScenarioId" },
        ],
        columns: [],
        data: [],
        highLightInfo: {
          val: "scenarioId",
          ids: [],
        },
        height: "500px",
      },
      colorItems: [],
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      requestImprRow: null,
      imprData: null,
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 20 + "px"
        : "500px";
    },
    imprComponent() {
      let components = null;
      if (!this.param.vendorFlag) {
        components = () => import(`${"@/pages/common/ibm/tableImpr.vue"}`);
      } else {
        components = () => import(`${"@/pages/ram/4m/4mTableImpr.vue"}`);
      }
      return components;
    },
    requestContentsCols() {
      return ["jobName", "ram4mRiskHazardClassName", "riskHazardName"];
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = this.param.vendorFlag ?  selectConfig.ram.fm.riskReduce.impr.url : selectConfig.ram.fm.riskReduce.list.url;
      // code setting
      if (!this.param.vendorFlag) {
        this.$comm.getStepItems("IBM_STEP_CD").then((_result) => {
          this.gridImpr.columns = [
            {
              name: "processName",
              field: "processName",
              label: "제조공정",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "jobName",
              field: "jobName",
              label: "공정흐름(작업절차)",
              align: "left",
              style: "width:150px",
              sortable: false,
            },
            {
              name: "ram4mRiskHazardClassName",
              field: "ram4mRiskHazardClassName",
              // 평가구분(4M)
              label: "LBL0001112",
              align: "left",
              style: "width:140px",
              sortable: false,
            },
            {
              name: "riskHazardName",
              field: "riskHazardName",
              // 유해위험요인
              label: "LBL0001050",
              align: "left",
              style: "width:170px",
              sortable: false,
            },
            // {
            //   name: 'relationLaw',
            //   field: 'relationLaw',
            //   // 관련법규
            //   label: 'LBL0001021',
            //   align: 'left',
            //   style: 'width:120px',
            //   sortable: false,
            // },
            // {
            //   name: 'damageTargetName',
            //   field: 'damageTargetName',
            //   // 피해대상
            //   label: 'LBL0001185',
            //   align: 'left',
            //   style: 'width:120px',
            //   sortable: false,
            // },
            {
              name: "damageTypeNameName",
              field: "damageTypeNameName",
              // 재해형태
              label: "LBL0001186",
              align: "left",
              style: "width:120px",
              sortable: false,
            },
            {
              name: "existingRiskManagementActivities",
              field: "existingRiskManagementActivities",
              label: "현재안전조치",
              align: "left",
              style: "width:180px",
              sortable: false,
            },
            {
              name: 'picture',
              field: 'picture',
              label: '개선 전/후 사진',
              align: 'center',
              type: 'custom',
              style: 'width:70px',
              sortable: false,
            },
            {
              name: "addingRiskManagementActivities",
              field: "addingRiskManagementActivities",
              label: "개선방향(대책)",
              align: "left",
              style: "width:180px",
              sortable: false,
            },
            {
              name: "improveFlagName",
              field: "improveFlagName",
              label: "개선진행여부",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "ibmTitle",
              field: "ibmTitle",
              // 제목
              label: "LBLTITLE",
              align: "left",
              type: "link",
              style: "width:300px",
              sortable: true,
            },
            {
              name: "ibmStepCd",
              field: "ibmStepCd",
              // 진행상태
              label: "LBLPROGRESS",
              align: "center",
              style: "width:100px",
              type: "tag",
              colorItems: _result,
              sortable: false,
            },
            {
              name: "improveRequest",
              field: "improveRequest",
              // 요청부서정보
              label: "요청부서정보",
              align: "center",
              style: "width:250px",
              sortable: true,
            },
            {
              name: "actionCompleteRequestDate",
              field: "actionCompleteRequestDate",
              // 조치완료요청일
              label: "LBL0001017",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
            {
              name: "actionDeptName",
              field: "actionDeptName",
              // 조치부서
              label: "LBL0001018",
              align: "center",
              style: "width:100px",
              sortable: true,
            },
          ];
          this.colorItems = _result;
        });
      } else {
        this.gridImpr.columns = [
          {
            name: "processName",
            field: "processName",
            label: "제조공정",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "공정흐름(작업절차)",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ram4mRiskHazardClassName",
            field: "ram4mRiskHazardClassName",
            // 평가구분(4M)
            label: "LBL0001112",
            align: "left",
            style: "width:140px",
            sortable: false,
          },
          {
            name: 'riskHazardPicture',
            field: 'riskHazardPicture',
            // 사진
            label: 'LBL0001175',
            align: 'center',
            style: 'width:40px',
            sortable: false,
            type: 'custom',
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 유해위험요인
            label: "LBL0001050",
            align: "left",
            style: "width:170px",
            sortable: false,
          },
          // {
          //   name: 'relationLaw',
          //   field: 'relationLaw',
          //   // 관련법규
          //   label: 'LBL0001021',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          // {
          //   name: 'damageTargetName',
          //   field: 'damageTargetName',
          //   // 피해대상
          //   label: 'LBL0001185',
          //   align: 'left',
          //   style: 'width:120px',
          //   sortable: false,
          // },
          {
            name: "damageTypeNameName",
            field: "damageTypeNameName",
            // 재해형태
            label: "LBL0001186",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "existingRiskManagementActivities",
            field: "existingRiskManagementActivities",
            label: "현재안전조치",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: 'picture',
            field: 'picture',
            label: '개선 전/후 사진',
            align: 'center',
            type: 'custom',
            style: 'width:70px',
            sortable: false,
          },
          {
            name: "improveFlagName",
            field: "improveFlagName",
            label: "개선진행여부",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "addingRiskManagementActivities",
            field: "addingRiskManagementActivities",
            label: "개선방향(대책)",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            // 제목
            label: "LBLTITLE",
            align: "left",
            type: "link",
            style: "width:300px",
            sortable: true,
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            // 진행상태
            label: "LBLPROGRESS",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "actionCompleteDate",
            field: "actionCompleteDate",
            // 조치일
            label: "LBL0000594",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ];
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramRiskAssessmentPlanId: this.param.ramRiskAssessmentPlanId,
      };
      this.$http.request((_result) => {
        this.param.vendorFlag ? this.riskReduce.imprs = _result.data : this.$_.extend(this.riskReduce, _result.data);
      });
    },
    /* eslint-disable no-unused-vars */
    imprChange(data) {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
    },
    linkClick(row) {
      this.imprData = row;
      this.popupOptions.title = "LBLIMPROVE";
      // if (!this.param.vendorFlag) {
        this.popupOptions.param = {
          sopImprovementId: row.sopImprovementId,
        };
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      // } else {
      //   this.popupOptions.param = {
      //     ram4mAssessImprId: row.ram4mAssessImprId,
      //   };
      //   this.popupOptions.target = () =>
      //     import(`${"@/pages/ram/4m/risk/4mImprRiskReduceDetail.vue"}`);
      // }
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        this.$_.extend(this.imprData, result.col1);
        this.$refs["tableImpr"].$refs["compo-table"].resetVirtualScroll();
      }
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        // ram4mAssessImprIds: props.row.ram4mAssessImprIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/4m/action/4mScenarioImprPicture.vue"}`);
      this.popupOptions.width = "60%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
  },
};
</script>
